import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { AdministrativeManagementDigitalizationKpiCfg, AdministrativeManagementDigitalizationKpiCfgService } from "./administrativeManagementDigitalizationKpiCfg.service";
import { ImpersonationService } from "src/app/auth/apigee/impersonation.service";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

export class ClientDetail {
    public officeId: string;
    public nif: string;
    public name: string;
    public clientCode: number;
    public centerCode: number;
    public clientFiscalName: string;
    public centerSegment: string;
    public ToSAccepted: boolean;
}

export class ClientsWoESolutionDetailServiceData {
    public clients: ClientDetail[];
    public updateTimestamp: Date;
}

@Injectable()
export class ClientsWoESolutionDetailService extends KpiService<ClientsWoESolutionDetailServiceData> {
    public getClassName() { return "ClientsWoESolutionDetailService"; }

    constructor(
        private serviceCfg: AdministrativeManagementDigitalizationKpiCfgService,
        private apigeeService: ApigeeService,
        private impersonationService: ImpersonationService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ) {
        super(injector);
    }

    protected async update(): Promise<ClientsWoESolutionDetailServiceData> {

        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: ClientsWoESolutionDetailServiceData = null;
            try {
                let cfg: AdministrativeManagementDigitalizationKpiCfg = this.serviceCfg.getCfg();
                let url = cfg.clientsWoESolution.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id);
                result = await this.httpClient.post<ClientsWoESolutionDetailServiceData>(url, this.impersonationService.getNifImpersonate()).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters,"KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}
